export enum Searchdestinations {
  STUDIODETAIL = '/studio/detail',
  CLUBMITGLIEDWERDEN = '/clubmitglied-werden',
  STUDIODETAILCOUPONS = '/studio/detail#coupons',
}
